// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3BsQj","stBrandingStyle":"_1P8er","priceBenefitsWrapper":"NUDMx","priceBenefitsImage":"_1shlL","priceBenefitsGradient":"_3ioFY","priceBenefitsText":"_2MGrb"};